import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { initialsOf } from "@/lib/initials"
import { cn } from "@/lib/utils"

/**
 * Avatar for a room. Nothing in the product uploads a room picture, so
 * this is always the initials fallback.
 */
export function UserAvatar({
  name,
  className,
  accent = false,
}: {
  name: string
  className?: string
  /** Tints the tile with the primary colour, for the room currently open. */
  accent?: boolean
}) {
  return (
    <Avatar className={cn("rounded-md", className)}>
      {/* The tint is a translucent layer of the primary colour rather than
          `bg-primary/15`: that utility is `color-mix()` with a solid-colour
          fallback, so a browser without it (Chrome ≤110) painted a solid
          primary disc behind primary-coloured initials — an unreadable
          blob. Opacity on a pseudo-element reads the same everywhere. */}
      <AvatarFallback
        className={cn(
          "text-xs font-medium",
          accent &&
            "relative isolate bg-transparent text-primary before:absolute before:inset-0 before:-z-10 before:rounded-[inherit] before:bg-primary before:opacity-15"
        )}
      >
        {initialsOf(name)}
      </AvatarFallback>
    </Avatar>
  )
}
